import { http } from "@/lib/http";
export function fetchGuidelineLink() {
  return http
    .get("/api/stamp/getGuidelineLink")
    .then((res) => res.data?.data?.guideline ?? "");
}
export function updateGuidelineLink(guideline) {
  return http
    .post("/api/stamp/updateGuidelineLink", { guideline })
    .then((res) => res.data);
}
export function fetchStampLimits() {
  return http
    .get("/api/stamp/getLimits")
    .then((res) => res.data?.data?.stamp_limits || []);
}
export function updateStampLimits(limits) {
  return http.post("/api/stamp/updateLimits", limits).then((res) => res.data);
}
export function fetchRecognitionStamps() {
  return http.get("/api/stamp/get_all_posts").then((res) => res.data);
}
export function fetchStampNotices() {
  return http.get("/api/messages/get_stamps").then((res) => res.data);
}
export function archiveStamps() {
  return http.post("/api/stamp/archive").then((res) => res.data);
}
export function deleteStamp(id) {
  return http.delete(`/api/stamp/delete/${id}`).then((res) => res.data);
}
export function exportStampsUrl() {
  return `${import.meta.env.VITE_API_BASE_URL || ""}/api/stamp/export`;
}
/**
 * The backend stores featured stamps as a single array field (`featured_list`)
 * on one document — there is no per-item id, only a positional `index` that
 * addFeatured/editFeatured/deleteFeatured match against.
 */
export function fetchFeaturedStamps() {
  return http
    .get("/api/stamp/getFeatured")
    .then((res) => res.data?.featured_list || []);
}
export function fetchStampImages() {
  return http.get("/api/stamp/getImages").then((res) => res.data?.stamps || []);
}
export function addFeaturedStamp(payload) {
  return http.post("/api/stamp/addFeatured", payload).then((res) => res.data);
}
export function editFeaturedStamp(payload) {
  return http.post("/api/stamp/editFeatured", payload).then((res) => res.data);
}
export function deleteFeaturedStamp(index) {
  return http
    .post("/api/stamp/deleteFeatured", { index })
    .then((res) => res.data);
}
